import { updateCounts } from 'features/asset/desktop';
import { utagLinkHeader } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

window.lp.utils = {
	...window.lp.utils,
	getAssetCounts: updateCounts
};

const trackHeaderEvent = utagLinkHeader();

function initHeaderTracking () {

	function getSaleElementParams (el) {

		if (!(el instanceof Element)) {

			throw new Error('Element was not provided');

		}

		if (!('saletype' in el.dataset)) {

			throw new Error('Element must have "saletype" data attribute');

		}

		const eventParams = { eventAction: 'click-Sale' };
		const { saletype } = el.dataset;

		switch (saletype) {

			case 'sale':
				return { ...eventParams, eventLabel: 'Sale' };
			case 'clearance':
				return { ...eventParams, eventLabel: 'Clearance' };
			case 'daily sales':
				return { ...eventParams, eventLabel: 'Daily Sales' };
			case 'openbox':
				return { ...eventParams, eventLabel: 'Open Box' };
			case 'pros specials':
				return { ...eventParams, eventLabel: 'Pros Specials' };
			default:
				return eventParams;

		}

	}

	const logoElement = document.querySelector('#logo');
	const signOutLink = document.querySelector('#hdrSignOut');
	const orderHistoryLink = document.querySelector('#hdrOrderHistory');
	const manageAccountLink = document.querySelector('#hdrAccountManage');
	const freeShippingElement = document.querySelector('#lpHeader-hdrPortal .freeShippingHeader');
	const mainCategoryLinks = document.querySelectorAll('#lpHeader-navWrapper--nav .aNavBtn');
	const prosHeaderLink = document.querySelector('#pros');
	const saleCategoryDropdownLinks = document.querySelectorAll('#saleMenu a[data-saletype]');
	const cartButton = document.querySelector('#yourCheckoutButton');
	const wishlistElement = document.querySelector('a[data-header-wishlist]');
	const savedRooms = document.querySelector('#savedPortfolio-yourRooms');
	const storesLink = document.querySelector('#bopusSubmenu');
	const phoneLink = document.querySelector('#liveChatLink');
	const employeeToolsLink = document.querySelector('#hdrEmployeeTools');
	const myOrdersLink = document.querySelector('#hdrMyOrders');
	const recentlyViewedLink = document.querySelector('#hdrRecentlyViewed');
	const storeLocationsButton = document.querySelector('#stores .storeLocationsButton');

	const aSaleLink = document.querySelector('#aSale');
	const aSaleBanner = document.querySelector('.salesDropdownBanner');
	const saleDropMenuItems = document.querySelectorAll(
		'#saleMenu a[data-saletype]'
	);

	if (employeeToolsLink) {

		employeeToolsLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Employee-Tools', eventLabel: window.location.pathname });
				setGenericEvent({ event_name: 'navtop_Employee Tools_click' });

			},
			{ once: true }
		);

	}

	if (myOrdersLink) {

		myOrdersLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-My-Orders', eventLabel: window.location.pathname });
				setGenericEvent({ event_name: 'navtop_My Orders_click' });

			},
			{ once: true }
		);

	}

	if (recentlyViewedLink) {

		recentlyViewedLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({
					eventAction: 'click-LoggedIn-Recently-Viewed',
					eventLabel: window.location.pathname
				});
				setGenericEvent({ event_name: 'navtop_Recently Viewed_click' });

			},
			{ once: true }
		);

	}

	if (signOutLink) {

		signOutLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-LoggedIn-Sign-Out', eventLabel: window.location.pathname });
				setGenericEvent({ event_name: 'navtop_Sign Out_click' });

			},
			{ once: true }
		);

	}

	if (phoneLink) {

		phoneLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Phone-Number' });
				setGenericEvent({ event_name: 'navtop_phone_click' });

			},
			{ once: true }
		);

	}

	if (storesLink) {

		storesLink.addEventListener(
			'click',
			() => {

				setGenericEvent({ event_name: 'navtop_stores_click' });

			},
			{ once: true }
		);

	}

	if (wishlistElement) {

		wishlistElement.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Wishlist' });
				setGenericEvent({ event_name: 'navtop_wishlist_click' });

			},
			{ once: true }
		);

	}

	if (savedRooms) {

		savedRooms.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Saved-Rooms' });
				setGenericEvent({ event_name: 'navtop_savedrooms_click' });

			},
			{ once: true }
		);

	}

	if (cartButton) {

		cartButton.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Cart' });
				setGenericEvent({ event_name: 'navtop_cart_click' });

			},
			{ once: true }
		);

	}

	if (logoElement) {

		logoElement.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Logo' });
				setGenericEvent({ event_name: 'navtop_logo_click' });

			},
			{ once: true }
		);

	}

	if (orderHistoryLink) {

		orderHistoryLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-LoggedIn-Order-History', eventLabel: window.location.pathname });
				setGenericEvent({ event_name: 'navtop_Order History_click' });

			},
			{ once: true }
		);

	}
	if (manageAccountLink) {

		manageAccountLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Manage-Account', eventLabel: window.location.pathname });
				setGenericEvent({ event_name: 'navtop_Manage Account_click' });

			},
			{ once: true }
		);

	}

	if (freeShippingElement) {

		freeShippingElement.addEventListener('click', () => trackHeaderEvent({ eventAction: 'click-Free-Shipping' }));

	}

	// category navigation tracking
	mainCategoryLinks.forEach((topCategoryLink) => {

		const subCategoryDropdowns = topCategoryLink.parentElement.querySelector('.categoryDropDowns');
		const topCategoryText = topCategoryLink.textContent.trim();
		const mainCategoryText = topCategoryLink.textContent.replace(/é/g, 'e').trim();

		topCategoryLink.addEventListener('click', () => {

			trackHeaderEvent({ eventAction: 'click-Category', eventLabel: topCategoryText });
			setGenericEvent({ event_name: `navtop_cat_${mainCategoryText}_click` });

		});

		subCategoryDropdowns.querySelectorAll('a').forEach((subCategoryLink) => {

			const isBanner = subCategoryLink.classList.contains('dropDownSplash');
			const subCategoryLinkTxt = subCategoryLink.textContent.replace('>', '').trim();
			const eventAction = 'click-Category-Navigation';
			const eventLabel = isBanner
				? `${topCategoryText}-Banner`
				: `${topCategoryText}-${subCategoryLinkTxt}`;
			const cleanedSubCategoryText = subCategoryLinkTxt
				.replace(/é/g, 'e')
				.replace(/\s+/g, ' ')
				.trim();
			const eventName = isBanner
				? `navtop_cat_${mainCategoryText}_banr_click`
				: `navtop_cat_${mainCategoryText}_${cleanedSubCategoryText}_click`;

			subCategoryLink.addEventListener(
				'click',
				() => {

					trackHeaderEvent({ eventAction, eventLabel });
					setGenericEvent({ event_name: eventName });

				},
				{
					once: true
				}
			);

		});

	});

	saleCategoryDropdownLinks.forEach((saleDropdownLink) => {

		saleDropdownLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent(getSaleElementParams(saleDropdownLink));

			},
			{ once: true }
		);

	});

	if (saleDropMenuItems) {

		saleDropMenuItems.forEach((saleDropMenuItem) => {

			const saleLabel = saleDropMenuItem.textContent.replace(/\s+/g, '-');

			saleDropMenuItem.addEventListener(
				'click',
				() => {

					trackHeaderEvent({ eventAction: 'click-Sale', eventLabel: saleLabel });

				},
				{ once: true }
			);

		});

	}

	if (prosHeaderLink) {

		prosHeaderLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Pros' });
				setGenericEvent({ event_name: 'navtop_pros_click' });

			},
			{
				once: true
			}
		);

	}

	if (aSaleLink) {

		aSaleLink.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Sale', eventLabel: 'Main' });
				setGenericEvent({ event_name: 'navtop_sale_main_click' });

			},
			{ once: true }
		);

	}

	if (aSaleBanner) {

		aSaleBanner.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Sale', eventLabel: 'Banner' });
				setGenericEvent({ event_name: 'navtop_sale_banner_click' });

			},
			{ once: true }
		);

	}

	if (storeLocationsButton) {

		storeLocationsButton.addEventListener(
			'click',
			() => {

				trackHeaderEvent({ eventAction: 'click-Stores' });
				setGenericEvent({ event_name: 'navtop_stores_click' });

			},
			{ once: true }
		);

	}

}

export default initHeaderTracking;
